import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

import registerScanbat from '@/common/api/register/registerScanbat';
import Snack from '@/common/components/molecules/Snack/Snack';

const useRegisterScanbat = () => {
  const { t } = useTranslation();

  return useMutation(registerScanbat, {
    onError: (error) => {
      if (error.response.status === 500) {
        toast.error(
          <Snack message={t('common:messages:forms.errors.server_error')} />,
        );
      } else {
        toast.error(
          <Snack message={t('common:messages:forms.errors.default')} />,
        );
      }
    },
    onSuccess: () => {
      toast.success(
        <Snack message={t('common:messages:forms.success.default')} />,
      );
    },
  });
};

export default useRegisterScanbat;
